<template>
  <!-- <div class="flex-row align-items-left"> -->
  <div>
    <video v-if="enableVideo" :key="videosource" autoplay muted loop id="video2" type="video/mp4" width="100vw" height="100vh"
      class="loginBackground" v-on:canplay="CanPlayVideo()" v-playback-rate="playbackRate">
      <source :src="videosource" />
    </video>
    <div style="position:absolute, top: 5vh, left:5vw; z-index:5;width:2vw">
      <b-button style="background-color:transparent" @click="updateVideoSource">
        <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
      </b-button>
      <!-- <b-input v-model="playbackRate" type="range" min="0.1" max="5" step=".1" width="3vw" orient="vertical"></b-input> -->
    </div>
    <img v-if="!playVideo" src="./../../assets/img/a-sky-view-of-earth-from-suomi-npp_16611703184_o_small.jpg"
      style="z-index:0" class="loginBackground" />
    <div class="container loginContainer">
      <br />
      <br />
      <br />
      <br />
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4 inlogruta">
              <b-card-body>
                <b-form>
                  <b-container align-h="center">
                    <b-row align-h="center">
                      <b-col>
                        <!-- <img src="./../../assets/img/brand/rexellogga.png" />
                        <br> -->
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <h1>Välkommen till {{ getSettings().applicationTitle }}</h1>
                      </b-col>
                    </b-row>
                  </b-container>
                  <hr />
                  <br />
                  <h3>Logga in</h3>
                  <p class="text-muted">
                    Logga in med dina inloggningsuppgifter
                  </p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <!-- <i class="icon-user"></i> -->
                        <b-icon-person></b-icon-person>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <input ref="username" type="text" class="form-control" placeholder="Användarnamn"
                      autocomplete="username email" v-model="userName" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <!-- <i class="icon-lock"></i> -->
                        <b-icon-lock></b-icon-lock>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <input ref="pwd" type="password" class="form-control" placeholder="Lösenord"
                      autocomplete="current-password" v-model="pwd" @keydown="pwdkeydown" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="8">
                      <b-button variant="primary" class="px-4" v-on:click="login()">
                        Login
                        <b-icon v-if="isBusy" icon="arrow-clockwise" animation="spin" font-scale="1"></b-icon>
                      </b-button>
                    </b-col>
                    <b-col align-h="end">
                      <a href="https://www.logivia.se">
                        <img src="./../../assets/img/brand/logivialogga_transp.png" width="139"
                          alt="Logivia - Logistics. But Smarter." />
                      </a>
                    </b-col>
                  </b-row>
                  <b-row>
                    <hr />
                  </b-row>
                  <b-row>
                    <b-col align-h="end"><small>Version: {{ getSettings().version }}
                        {{ getSettings().baseUrl }}</small></b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { Api } from "../../lib/api";
import Settings from "../../lib/settings";
import User from "../../lib/user";

const api = new Api();

const videoSources = [
  { url: 'Our%20Planet%20Our%20Home%20An%20Earth%20Day%20Perspective/Our%20Planet%20Our%20Home%20An%20Earth%20Day%20Perspective~small.mp4', start: 1, end: 125, rate: 0.5 },
  { url: 'NHQ_2019_0626_Earth%20Views%20from%20the%20ISS/NHQ_2019_0626_Earth%20Views%20from%20the%20ISS~small.mp4', start: 1, end: 2640, rate: 0.5 },
  { url: 'GSFC_20190207_LRO_m13144_Impacts/GSFC_20190207_LRO_m13144_Impacts~small.mp4', start: 0, end: 9, rate: 0.5 },
  { url: 'GSFC_20190207_LRO_m13144_Impacts/GSFC_20190207_LRO_m13144_Impacts~small.mp4', start: 38, end: 60, rate: 0.5 },
  { url: 'jsc2015m000185/jsc2015m000185~small.mp4', start: 0, end: 13, rate: 0.5 },
  { url: 'jsc2015m000272/jsc2015m000272~small.mp4', start: 0, end: 5, rate: 0.5 },
  { url: 'GSFC_20130927_IPCC%20m11376_21st/GSFC_20130927_IPCC%20m11376_21st~small.mp4', start: 6, end: 230, rate: 0.5 },
  { url: 'KSC-19640101-MH-NAS01-0001-The_Crawler_Transporter_The_Beginning_Historical_Footage-B_2309/KSC-19640101-MH-NAS01-0001-The_Crawler_Transporter_The_Beginning_Historical_Footage-B_2309~small.mp4', start: 30, end: 90, rate: 0.5 },
  { url: '311_ScienceCasts-observing-lightning-ISS/311_ScienceCasts-observing-lightning-ISS~small.mp4', start: 0, end: 15, rate: 0.5 },
  { url: '311_ScienceCasts-observing-lightning-ISS/311_ScienceCasts-observing-lightning-ISS~small.mp4', start: 24, end: 34, rate: 0.5 },
  { url: '311_ScienceCasts-observing-lightning-ISS/311_ScienceCasts-observing-lightning-ISS~small.mp4', start: 24, end: 34, rate: 0.5 },
  { url: 'GSFC_20150212_Drought_m11776_21st_Century_1/GSFC_20150212_Drought_m11776_21st_Century_1~small.mp4', start: 0, end: 13, rate: 0.5 },
  { url: 'GSFC_20150212_Drought_m11776_21st_Century_1/GSFC_20150212_Drought_m11776_21st_Century_1~small.mp4', start: 28, end: 80, rate: 0.5 },
  { url: 'GSFC_20150212_Drought_m11776_21st_Century_1/GSFC_20150212_Drought_m11776_21st_Century_1~small.mp4', start: 90, end: 120, rate: 0.5 },
]

export default {
  name: "Login",
  data() {
    return {
      userName: "",
      pwd: "",
      isBusy: false,
      playVideo: false,
      videosource: null,
      currsource: null,
      playbackRate: 5,
      enableVideo:false,
    };
  },
  created() {
    this.updateVideoSource();
  },
  mounted() {
    this.userName = localStorage.getItem("username");
    if (!this.userName) {
      this.userName = "";
      this.$refs.username.focus();
    } else {
      this.$refs.pwd.focus();
    }
  },
  directives: {
    playbackRate(el, binding) {
      el.playbackRate = binding.value;
    }
  },
  methods: {
    updateVideoSource() {
      if(!this.enableVideo)
        return;
        
      this.playVideo = false;
      console.log('Update video:')

      var src = this.currsource;
      //Make sure it is a new one
      while (src === this.currsource) {
        var idx = Math.floor(Math.random() * videoSources.length);
        src = videoSources[idx];
      }
      this.currsource = src;
      let u = this.getSettings().videofolder;
      if (!u.startsWith('http')) { //Take just filename
        var pathels = src.url.replace('~', '_').split('/');
        u += pathels[pathels.length - 1];
      } else {
        u += src.url;
      }

      var st = src.start ? src.start : 0;
      var en = src.end ? src.end : 9999;
      u += `#t=${st},${en}`;
      this.videosource = u;
      this.playbackRate = src.rate ? src.rate : 1;

      console.log(src);


      if (src.end)
        setTimeout(this.updateVideoSource, 1000 * (src.end - src.start) / this.playbackRate);
    },
    login() {
      if (!this.isBusy) {
        this.isBusy = true;
        api.login(this.userName, this.pwd).then(
          (ok) => {
            this.isBusy = false;
            const usr = new User();
            var isLoggedIn = usr.IsLoggedIn();
            if(!isLoggedIn) {
              //alert('Försök igen');
              return;
            }
            localStorage.setItem("username", this.userName);
            console.log(ok);
            //top.location = "/";
            if (this.$route.params.nextUrl != null) {
              this.$router.push(this.$route.params.nextUrl);
            } else {
              this.$router.push({ path: "/home" });
            }
          },
          (err) => {
            alert('Ett fel uppstod vid inloggningen. Vänligen försök igen.');

            console.log(err);
            this.isBusy = false;

          }
        );
      }
    },
    pwdkeydown(ev) {
      if (ev.keyCode == 13 && this.pwd != "") this.login();
    },
    getSettings() {
      return Settings;
    },
    CanPlayVideo() {
      //alert('Klar!');
      this.playVideo = true;
    }
  },
};
</script>
<style scoped>
.loginBackground {
  position: absolute;
  left: 0px;
  top: 0px;
  height: auto;
  width: 100%;
  z-index: -1;
}

.videoBackground {
  position: absolute;
  left: 0px;
  top: 0px;
  height: auto;
  width: 100%;
  z-index: -1;
}

.loginContainer {
  /* position: absolute; */
  vertical-align: center;
  /* top: 30px; */
  /* left: 50%; */
  align-self: center;
}

.inlogruta {
  background-color: lightgray;
}

#myVideo {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
}

input[type=range][orient=vertical] {
  writing-mode: bt-lr;
  /* IE */
  -webkit-appearance: slider-vertical;
  /* Chromium */
  width: 8px;
  height: 175px;
  padding: 0 5px;
}
</style>